/**
 * Canonical UUID shape check for route params and other untrusted ids.
 *
 * Postgres rejects any non-UUID string bound to a uuid column with
 * `invalid input syntax for type uuid` (22P02). Literal path segments like
 * "/prioritization/items/intake" match `:itemId` routes, so every id that
 * comes from a URL must pass this check before it is used in a DB query —
 * a bad segment should render a not-found state, not fire a doomed query.
 *
 * Deliberately shape-only (no version/variant bits): all ids we generate
 * (`crypto.randomUUID`, `gen_random_uuid()`) are 8-4-4-4-12 hex, and a
 * version-strict regex would wrongly reject legitimate ids such as the nil
 * UUID or future v7 ids.
 */
export const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value: string | null | undefined): value is string {
  return typeof value === 'string' && UUID_RE.test(value);
}
